import { Component } from '@theme/component';

/**
 * MOXIE: desktop es hover 100% CSS, esto solo cubre next/previous del scroll-snap mobile.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} track
 *
 * @extends {Component<Refs>}
 */
export class CustomCollectionAccordion extends Component {
  requiredRefs = ['track'];

  next() {
    this.refs.track.scrollBy({ left: this.refs.track.clientWidth, behavior: 'smooth' });
  }

  previous() {
    this.refs.track.scrollBy({ left: -this.refs.track.clientWidth, behavior: 'smooth' });
  }
}

if (!customElements.get('custom-collection-accordion')) {
  customElements.define('custom-collection-accordion', CustomCollectionAccordion);
}
